// extracted by mini-css-extract-plugin
export default {"viewMoreLoader":"banList_viewMoreLoader__L7sOc","container":"banList_container__+aWwG","center":"banList_center__pwmL6"};